import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { Router } from 'react-router-dom';
import { ErrorBoundary } from '@sentry/react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import { history } from '_app/app/history';
import { queryClient } from '_app/app/queryClient';
import { store } from '_app/app/store';
import { useSessionBootstrap, useSessionRouting } from '_app/features/session';

import 'react-phone-number-input/style.css';
import './styles/tailwind.css';
import './styles/global.css';
import './styles/custom.css';
import 'react-toastify/dist/ReactToastify.css';
import '_app/styles/fontAwesome';

import Pages from '_app/pages';
import { Env } from './config';
import { ErrorReport } from './components';

Sentry.init({
  dsn: Env.SENTRY_DSN,
  integrations: [
    new Integrations.BrowserTracing({
      // Can also use reactRouterV3Instrumentation or reactRouterV4Instrumentation
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],
  tracesSampleRate: 1.0,
});

const AppShell = () => {
  useSessionRouting();
  useSessionBootstrap();

  return (
    <>
      <Pages />
      <ToastContainer theme="colored" />
    </>
  );
};

const App = () => (
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary
        fallback={({ error, componentStack, resetError }) => <ErrorReport error={error} componentStack={componentStack} resetError={resetError} />}
      >
        <Router history={history}>
          <AppShell />
        </Router>
      </ErrorBoundary>
    </QueryClientProvider>
  </Provider>
);

export default App;
